
import { defineComponent, PropType } from 'vue'
import SquareController from '@/types/SquareController';
import GuessComponent from '@/components/GuessComponent.vue';
import WordComponent from '@/components/WordComponent.vue';
import GuessCount from '@/components/GuessCount.vue';


export default defineComponent({
    emits: [ 'onGuessCountPressed' ],
    components: {
        GuessComponent,
        WordComponent,
        GuessCount,
    },
    props: {
        squareController: {
            required: true,
            type: Object as PropType<SquareController>
        }
    }
})
